<template>
  <main class="flex min-h-screen items-center justify-center bg-background px-6 py-10 text-foreground">
    <section class="w-full max-w-md border border-border bg-card p-8 text-card-foreground shadow-sm">
      <div class="space-y-5">
        <div class="flex size-12 items-center justify-center border border-border bg-muted text-primary">
          <AlertTriangle class="size-5" />
        </div>

        <div class="space-y-2">
          <h1 class="text-2xl font-semibold">{{ t("portalUnavailable.title") }}</h1>
          <p class="text-sm leading-6 text-muted-foreground">
            {{ t("portalUnavailable.description") }}
          </p>
        </div>

        <button
          class="inline-flex h-10 items-center gap-2 bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
          type="button"
          @click="reload"
        >
          <RefreshCw class="size-4" />
          {{ t("portalUnavailable.retry") }}
        </button>
      </div>
    </section>
  </main>
</template>

<script setup lang="ts">
import { AlertTriangle, RefreshCw } from "lucide-vue-next";
import { useI18n } from "@/lib/i18n";

const { t } = useI18n();

function reload() {
  window.location.reload();
}
</script>
